import styles from "../../../styles/shared/create-bot/CreateBotSettings.module.css";
import React from "react";
import { InputNumber } from "antd";
import { TbReportSearch } from "react-icons/tb";
import { FaMinus, FaPlus } from "react-icons/fa6";

const percentFormatter = (value) => `${value}%`;
const percentParser = (value) => value.replace("%", "");

function TargetReturnsSettings({ changeConfig, targetReturns }) {
  const controllerHandler = (action) => () => {
    const currentValue = Number(targetReturns);

    if (action === "minus") {
      if (currentValue === 0 || currentValue === 1) return;
      changeConfig("target_return_percentage", `${currentValue - 1}`);
    } else {
      if (currentValue === 100) return;
      changeConfig("target_return_percentage", `${currentValue + 1}`);
    }
  };

  return (
    <>
      <div className={styles.stepTitle}>
        <h6>
          <TbReportSearch color="#0c4cfc" size={18} /> What monthly percentage
          return are you aiming for in your crypto portfolio?
        </h6>
      </div>

      <div className={styles.inputNumberContainer}>
        <span
          className={`${styles.inputController} ${Number(targetReturns) === 1 ? styles.disabledController : ""}`}
          onClick={controllerHandler("minus")}
        >
          <FaMinus />
        </span>
        <InputNumber
          min={1}
          max={100}
          formatter={percentFormatter}
          parser={percentParser}
          style={{ borderRadius: ".3rem" }}
          value={targetReturns}
          controls={false}
          onChange={(value) => {
            changeConfig("target_return_percentage", `${value}`);
          }}
        />
        <span
          className={`${styles.inputController} ${Number(targetReturns) === 100 ? styles.disabledController : ""}`}
          onClick={controllerHandler("plus")}
        >
          <FaPlus />
        </span>
      </div>
    </>
  );
}

export default TargetReturnsSettings;
